export default __webpack_public_path__ + "static/states_of_matter-259154904ec7cb32779af935a3add8c8.jpg";